
























import Vue from "vue";

export default Vue.extend({
  props: ["forecast"],
  data: () => ({
    tabs: [
      {
        id: 0,
        name: "Temperature (°C)",
        icon: "mdi-thermometer",
        data: [] as any
      },
      {
        id: 1,
        name: "Humidity (%)",
        icon: "mdi-water-percent",
        data: [] as any
      },
      { id: 2, name: "Wind (m/s)", icon: "mdi-weather-windy", data: [] as any }
    ]
  }),
  created() {
    this.groupValues();
  },
  watch: {
    forecast(newValue, oldValue) {
      this.groupValues();
    }
  },
  methods: {
    groupValues() {
      this.tabs[0].data = [];
      this.tabs[1].data = [];
      this.tabs[2].data = [];

      this.forecast.forEach((f: any) => {
        this.tabs[0].data.push(f.main.temp);
        this.tabs[1].data.push(f.main.humidity);
        this.tabs[2].data.push(f.wind.speed);
      });
    }
  }
});
